Namespace 'CustomerVisualMode.Filters.LastInterval.Converters'

class CustomerVisualMode.Filters.LastInterval.Converters.DayConverter
  constructor: ->
    @aDayInSeconds = moment.duration(1, 'days').asSeconds()

  toSeconds: (day) ->
    {
      name: @_label(day)
      interval: @_daysInSeconds(day)
    }

  canConvert: (seconds) ->
    (seconds % @aDayInSeconds) == 0

  getLabelFromSeconds: (seconds) ->
    days = Math.round(moment.duration(seconds, 'seconds').asDays())
    @_label(days)

  _daysInSeconds: (day) ->
    moment.duration(day, 'days').asSeconds()

  _label: (day) ->
    I18n.t('customer_visual_mode.filters.date.last_interval.day', count: day)
